import { render, staticRenderFns } from "./home-tr.vue?vue&type=template&id=f97891a0&scoped=true"
import script from "./home-tr.vue?vue&type=script&lang=js"
export * from "./home-tr.vue?vue&type=script&lang=js"
import style0 from "./home-tr.vue?vue&type=style&index=0&id=f97891a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97891a0",
  null
  
)

export default component.exports